import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取设备分类树
export function getDeviceTypeTree (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/tree',
    method: 'GET',
    params: parameter
  })
}
// 设备类型详情
export function getDeviceTypeInfo (id) {
  return axios({
    url: sysInfo.apiRemote + `/equipment/type/${id}`,
    method: 'GET'
  })
}
// 新增设备类型
export function addDeviceType (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/save',
    method: 'POST',
    data: parameter
  })
}
// 设备类型编辑
export function editDeviceType (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/edit',
    method: 'PUT',
    data: parameter
  })
}

// 设备类型删除
export function delDeviceType (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/delete',
    method: 'DELETE',
    data: parameter
  })
}

// 设备类型拖拽
export function dragDeviceType (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/drag',
    method: 'PUT',
    data: parameter
  })
}

// 获取特性列表
export function getFeatureList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/peculiaritys',
    method: 'GET',
    params: parameter
  })
}
// 校验是否存在数据
export function getCheckExistenceValue (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/checkDelete',
    method: 'GET',
    params: parameter
  })
}
// 检测设备特性是否关联
export function getCheckPeculiarity (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/checkPeculiarity',
    method: 'GET',
    params: parameter
  })
}
// 新增特性
export function addFeature (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/peculiarity/save',
    method: 'POST',
    data: parameter
  })
}
// 检测设备参数是否关联
export function checkParam (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/checkParam',
    method: 'GET',
    params: parameter
  })
}
// 校验此自定义参数是否跟此设备类型关联且存在数据
export function checkTypeParam (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/checkTypeParam',
    method: 'GET',
    params: parameter
  })
}
// 校验自定义参数/基础参数/特性 是否配置台账展示
export function checkFidleDelete (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/checkFieldDelete',
    method: 'GET',
    params: parameter
  })
}
// 校验自定义参数/基础参数/特性 是否配置台账展示
export function checkFieldDeleteByType (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/checkFieldDeleteByType',
    method: 'GET',
    params: parameter
  })
}
// 检测设备参数是否关联
export function checkPeculiarity (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/checkPeculiarity',
    method: 'GET',
    params: parameter
  })
}
// 参数配置保存
export function addParam (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/param/save',
    method: 'POST',
    data: parameter
  })
}
// 获取参数配置信息
export function getParams (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/getParams',
    method: 'GET',
    params: parameter
  })
}
// 获取基础字段
export function getBaseField (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/query',
    method: 'GET',
    params: parameter
  })
}
// 根据设备类型code 获取已配置的字段
export function getTypeFieldByTypeCode (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/getTypeFieldByTypeCode',
    method: 'GET',
    params: parameter
  })
}
// 获取字段配置参数和特性数据
export function getTypeFieldDataByTypeId (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/getTypeFieldDataByTypeId',
    method: 'GET',
    params: parameter
  })
}
// 保存台账字段配置
export function saveTypeField (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/saveTypeField',
    method: 'POST',
    data: parameter
  })
}
// 设备类型-参数配置 删除常规参数校验
export function deleteCheckParam (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/deleteCheckParam',
    method: 'GET',
    params: parameter
  })
}